import { render, staticRenderFns } from "./JobStatistics.vue?vue&type=template&id=0ff40fbc&scoped=true&"
import script from "./JobStatistics.vue?vue&type=script&lang=js&"
export * from "./JobStatistics.vue?vue&type=script&lang=js&"
import style0 from "./JobStatistics.vue?vue&type=style&index=0&id=0ff40fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff40fbc",
  null
  
)

export default component.exports